import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="aep-swift" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static var extensionVersion: String
`}</code></pre>
    <Variant platform="aep-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="acp-objc" api="extension-version" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (nonnull NSString*) extensionVersion;
`}</code></pre>
    <Variant platform="aep-swift" api="get-visitor-profile" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getVisitorProfile(completion: @escaping ([String: String]?, Error?) -> Void)
`}</code></pre>
    <Variant platform="aep-objc" api="get-visitor-profile" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getVisitorProfile:^(NSDictionary<NSString *,NSString *> * _Nullable visitorProfile, NSError * _Nullable error)completion
`}</code></pre>
    <Variant platform="acp-objc" api="get-visitor-profile" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) getVisitorProfile:^(NSDictionary * _Nullable visitorProfile) callback;

+ (void) getVisitorProfileWithCompletionHandler:^(NSDictionary * _Nullable visitorProfile, NSError * _Nullable error) completionHandler;
`}</code></pre>
    <Variant platform="aep-swift" api="reset" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func reset()
`}</code></pre>
    <Variant platform="aep-objc" api="reset" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) reset;
`}</code></pre>
    <Variant platform="acp-objc" api="reset" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) reset;
`}</code></pre>
    <Variant platform="aep-swift" api="signal-with-data" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func signalWithData(data: [String: String], completion: @escaping ([String: String]?, Error?) -> Void)
`}</code></pre>
    <Variant platform="aep-objc" api="signal-with-data" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) signalWithData:(NSDictionary<NSString *,NSString *> * _Nonnull data) completion:^(NSDictionary<NSString *,NSString *> * _Nullable vistorProfile, NSError * _Nullable error)completion
`}</code></pre>
    <Variant platform="acp-objc" api="signal-with-data" repeat="1" mdxType="Variant" />
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`+ (void) signalWithData: (NSDictionary<NSString *, NSString *> * _Nullable) data
                       callback:^(NSDictionary* _Nullable visitorProfile) callback;

+ (void) signalWithData: (NSDictionary<NSString *, NSString *> * _Nonnull) data
                        withCompletionHandler:^(NSDictionary * _Nullable visitorProfile, NSError *         _Nullable error) completionHandler;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      